import React from 'react';
import { Stack } from '@mui/material';
import EdgeTypeSelector from '../EdgeTypeSelector';
import { BumpoutEdgeTypes } from '../../context/DeckContext';
import EdgeType from '../../../../../../enums/edgeType';
import { Block, Edge } from '../../../../../../types/shared/blocks';

interface BumpoutEdgePopperProps {
	block: Block;
	blockEdge: Edge;
	inputEdge: EdgeType | undefined;
	setInputEdge: (edgeType: EdgeType) => void;
	onDropdownOpenChange?: (open: boolean) => void;
}

const BumpoutEdgePopper: React.FC<BumpoutEdgePopperProps> = ({
	blockEdge,
	inputEdge,
	setInputEdge,
	onDropdownOpenChange,
}) => {
	const isEdgeDisabled = blockEdge?.type === EdgeType.BLOCK_ATTACHED;

	return (
		<Stack spacing={1.25}>
			<EdgeTypeSelector
				edgeTypes={BumpoutEdgeTypes}
				value={inputEdge}
				onChange={setInputEdge}
				disabled={isEdgeDisabled}
				label="Edge Types"
				onDropdownOpenChange={onDropdownOpenChange}
			/>
		</Stack>
	);
};

export default BumpoutEdgePopper;
